import React from 'react';
interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressIndicator({
  currentStep,
  totalSteps
}: ProgressIndicatorProps) {
  return <div className="flex items-center gap-3" role="navigation" aria-label={`Step ${currentStep} of ${totalSteps}`} data-id="element-15">
      <span className="text-xs font-medium tracking-widest uppercase text-slate-400" data-id="element-16">
        {currentStep} / {totalSteps}
      </span>
      <div className="flex gap-1.5" data-id="element-17">
        {Array.from({
        length: totalSteps
      }, (_, i) => {
        const step = i + 1;
        const isActive = step === currentStep;
        const isPast = step < currentStep;
        return <div key={step} className={`h-1.5 rounded-full transition-all duration-500 ${isActive ? 'w-8 bg-teal-500' : isPast ? 'w-4 bg-teal-500/40' : 'w-4 bg-slate-200'}`} aria-current={isActive ? 'step' : undefined} data-id="element-18" />;
      })}
      </div>
    </div>;
}